const serializeForm = (form) => {
    const params = new URLSearchParams();

    new FormData(form).forEach((value, key) => {
        if (typeof value !== "string") {
            return;
        }

        const trimmed = value.trim();

        if (trimmed === "") {
            return;
        }

        params.set(key, trimmed);
    });

    params.sort();

    return params.toString();
};

const currentFilterQuery = () => {
    const params = new URLSearchParams(window.location.search);
    const next = new URLSearchParams();

    params.forEach((value, key) => {
        if (key === "page" || value === "") {
            return;
        }

        next.set(key, value);
    });

    next.sort();

    return next.toString();
};

export const registerImmediateFilterForm = (Alpine) => {
    Alpine.data(
        "immediateFilterForm",
        ({ debounceMs = 350, searchName = "search", selectNames = ["status"] } = {}) => ({
            debounceTimer: null,
            searchName,
            selectNames,

            onInput(event) {
                if (
                    !(event.target instanceof HTMLInputElement) ||
                    event.target.name !== this.searchName
                ) {
                    return;
                }

                this.submitSoon();
            },

            onChange(event) {
                if (
                    !(event.target instanceof HTMLSelectElement) ||
                    !this.selectNames.includes(event.target.name)
                ) {
                    return;
                }

                this.submitNow();
            },

            submitSoon() {
                window.clearTimeout(this.debounceTimer);
                this.debounceTimer = window.setTimeout(() => {
                    this.submitIfChanged();
                }, debounceMs);
            },

            submitNow() {
                window.clearTimeout(this.debounceTimer);
                this.submitIfChanged();
            },

            submitIfChanged() {
                if (!(this.$el instanceof HTMLFormElement)) {
                    return;
                }

                if (serializeForm(this.$el) === currentFilterQuery()) {
                    return;
                }

                this.$el.requestSubmit();
            },
        }),
    );
};
